<template>
<div>
    <h1>informaçõs sobre o plano de assinatura</h1>    
</div>
</template>
<script>
export default {
    name: 'SettingsPlans'    
}
</script>